import React, { useEffect, useState } from 'react'
import LoggedInUi from './LoggedInUi'
import Card from '../Components/Shared/Card'
import vibe from '../assets/vibe.png';
import security from '../assets/lock.png';
import connect from '../assets/connect.png';
import { Link, useNavigate, useNavigation } from 'react-router-dom';
import { useCookies } from 'react-cookie';

function LoggedInHome() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [cookie, setCookie] = useCookies(["token"]);
  const navigate = useNavigate();
  useEffect(()=>{
    if(cookie.token){
      setIsLoggedIn(true);
    }
  },[]);
  return (
        <LoggedInUi>
        <div className='text-black font-bold w-full h-[8%] my-[6vmax]  flex justify-center text-center items-center text-[3vmax]'>STILL CONFUSED WHOM TO CHOOSE?</div>
        <div className='text-black font-semibold text-[1.5vmax] gap-[1vmax] w-full h-[5%] flex justify-center items-center'><button onClick={(e)=>{
          e.preventDefault();
          if(isLoggedIn){
            navigate('/dashboard');
          }
          else if(!isLoggedIn){
            navigate('/signup');
          }
        }} style={{backgroundColor: '#f4e454'}} className='p-[0.7vmax] w-[22vmax] font-bold rounded-[0.5vmax] register-dashboard-button'>{isLoggedIn ? 'VISIT DASHBOARD' : 'REGISTER NOW'}</button>
        {isLoggedIn && <button onClick={(e)=>{
          navigate('/questionnaire');
        }} style={{backgroundColor: '#f4e454'}} className='p-[0.7vmax] w-[22vmax] font-bold rounded-[0.5vmax] update-dashboard-button'>UPDATE QUESTIONNAIRE</button>}
        </div>
        <div className='px-[1vmax] my-[5vmax] w-full h-[18vmax] flex gap-[12%]'>
            <Card photo={vibe} msg='FIND YOUR VIBE' />
            <Card photo={security} msg='SAFE AND VERIFIED' />
            <Card photo={connect} msg='CONNECT WITH PEOPLE' />
            </div> 
            <div className='w-full bg-black h-[0.1vmax] px-[0vmax]'>​</div>
            <div className='w-full h-[20%] text-center flex justify-center items-center my-[2vmax] text-[1.6vmax] font-semibold'>Are you still searching for a roomie? Unsure if you might get along well? Say goodbye to the stress for this one. FindMyRoomie connects people who are seeking roommate, across your batch. Browse through profiles, listing interests to living habits. Find your match, connect effortlessly through our platform and get going now! Happy First Year!!</div>
            <div className='w-full h-[0.1vmax] my-[1vmax] p-[0vmax] bg-black'>​</div>
            <footer className='text-black font-semibold text-[1vmax] w-full flex justify-center items-center'><div>©2024 FindMyRoomie. Made With ❤️ at NITT</div></footer>
        </LoggedInUi>
  )
}

export default LoggedInHome